import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const getStyles = (
  name: string,
  personName: readonly string[],
  theme: Theme,
): { fontWeight: React.CSSProperties['fontWeight'] } => {
  return {
    fontWeight: personName?.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
};
interface InputMultSelectDefaultProps {
  onChangeData?: (value: string[]) => void;
  labelName?: string;
  options?: { value: string; label: string }[];
  valueIn: string[];
}

export const MultipleSelectDefault: React.FC<InputMultSelectDefaultProps> = ({
  options,
  onChangeData,
  labelName,
  valueIn,
}) => {
  const theme = useTheme();
  //const [personName, setPersonName] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof valueIn>): boolean => {
    const {
      target: { value },
    } = event;
    if (onChangeData) {
      if (valueIn) {
        onChangeData(
          // On autofill we get a stringified value.
          typeof value === 'string' ? value.split(',') : value,
        );
      }
    }
    return true;
  };

  return (
    <div>
      <FormControl sx={{ width: '100%' }}>
        <InputLabel id="demo-multiple-chip-label">{labelName}</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          multiple
          value={valueIn}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label={labelName} />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.3 }}>
              {selected?.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {options &&
            options?.map(({ label }) => (
              <MenuItem
                key={label}
                value={label}
                style={getStyles(label, valueIn, theme)}
              >
                {label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

//export default MultipleSelectDefault;
